<div class="main-content">
  <div class="container-fluid">

    <loader *ngIf="loading"></loader>

    <ng-container *ngIf="!loading">

      <!-- KPI + Funding chart -->
      <div class="stats-row">
        <div class="kpi-card">
          <div class="kpi-label">Submitted Applications</div>
          <div class="kpi-value">{{ applications }}</div>
        </div>
        <div class="chart-card">
          <apx-chart class="chart-container"
                     [series]="fundingProgrammeChart.series"
                     [chart]="fundingProgrammeChart.chart"
                     [labels]="fundingProgrammeChart.labels"
                     [title]="fundingProgrammeChart.chartTitle"></apx-chart>
        </div>
      </div>

      <!-- Topics + Delivery status -->
      <div class="stats-row">
        <div class="chart-card">
          <apx-chart class="chart-container"
                     [series]="callTopicsChart.series"
                     [chart]="callTopicsChart.chart"
                     [labels]="callTopicsChart.labels"
                     [title]="callTopicsChart.chartTitle"></apx-chart>
        </div>
        <div class="chart-card">
          <apx-chart class="chart-container"
                     [series]="serviceDeliveryStatusChart.series"
                     [chart]="serviceDeliveryStatusChart.chart"
                     [labels]="serviceDeliveryStatusChart.labels"
                     [title]="serviceDeliveryStatusChart.chartTitle"></apx-chart>
        </div>
      </div>

      <!-- Highcharts + Completed projects table -->
      <div class="stats-row">
        <div class="chart-card">
          <highcharts-chart
            id="container"
            [Highcharts]="Highcharts"
            [constructorType]="chartConstructor"
            [options]="chartOptions"
            [update]="updateFlag"
            style="width: 100%; height: 400px; display: block;">
          </highcharts-chart>
        </div>

        <div class="stats-table-card">
          <div class="stats-table-header">
            <h5 class="stats-table-title">Completed projects</h5>
            <span class="stats-table-subtitle">Premium Service</span>
          </div>
          <div class="table-responsive">
            <table class="table table-hover">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Project</th>
                  <th class="text-right">Actual Duration</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let row of associationsArray | paginate: { itemsPerPage: itemsPerPage, currentPage: p }; let i = index">
                  <td>{{ calculateRowIndex(i) }}</td>
                  <td><a class="row-link" (click)="openNewTab('/#/project/'+row['project_id'])">{{ row['Project'] }}</a></td>
                  <td class="text-right">{{ row['ActualDuration'] }}</td>
                </tr>
              </tbody>
            </table>
            <pagination-controls class="custom-hover" (pageChange)="p = $event"></pagination-controls>
          </div>
        </div>
      </div>

    </ng-container>

  </div>
</div>


